import { useState, useCallback } from 'react';
import { LabelElement, LABEL_WIDTH_MM, LABEL_HEIGHT_MM } from '@/types/label';

const CLIPBOARD_KEY = 'label-forge-clipboard';

export const useClipboard = () => {
  const [clipboardElement, setClipboardElement] = useState<LabelElement | null>(() => {
    try {
      const stored = localStorage.getItem(CLIPBOARD_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const copyElement = useCallback((element: LabelElement) => {
    const elementCopy = JSON.parse(JSON.stringify(element));
    setClipboardElement(elementCopy);
    try {
      localStorage.setItem(CLIPBOARD_KEY, JSON.stringify(elementCopy));
    } catch {
      // Ignore localStorage errors
    }
  }, []);

  const pasteElement = useCallback((
    labelWidth: number = LABEL_WIDTH_MM,
    labelHeight: number = LABEL_HEIGHT_MM
  ): LabelElement | null => {
    if (!clipboardElement) return null;

    const newId = `${clipboardElement.type}-${Date.now()}`;
    const pastedElement: LabelElement = {
      ...JSON.parse(JSON.stringify(clipboardElement)),
      id: newId,
      position: {
        x: Math.min(clipboardElement.position.x + 2, labelWidth - clipboardElement.size.width),
        y: Math.min(clipboardElement.position.y + 2, labelHeight - clipboardElement.size.height),
      },
    };

    return pastedElement;
  }, [clipboardElement]);

  const hasClipboard = clipboardElement !== null;

  return {
    clipboardElement,
    copyElement,
    pasteElement,
    hasClipboard,
  };
};
